// VendTrade — shared UI helpers: color chips per category, direction pill,
// and a small "match reasons" list. Keeps individual pages small.
import { ArrowLeftRight, HandCoins, Handshake, Megaphone, Package, Wrench, Sparkles } from "lucide-react";

export const CATEGORIES = [
  { value: "products", label: "Products", icon: Package,
    color: "rgba(196,79,54,0.12)", ink: "var(--terracotta)" },
  { value: "services", label: "Services", icon: Wrench,
    color: "rgba(111,125,85,0.14)", ink: "var(--moss)" },
  { value: "resources", label: "Resources", icon: HandCoins,
    color: "rgba(212,171,79,0.16)", ink: "#7a5b12" },
  { value: "promotion", label: "Promotion", icon: Megaphone,
    color: "rgba(75,111,140,0.14)", ink: "#2f4b66" },
  { value: "misc", label: "Miscellaneous", icon: Sparkles,
    color: "rgba(120,90,140,0.14)", ink: "#4a2e63" },
];

export const CAT_MAP = Object.fromEntries(CATEGORIES.map((c) => [c.value, c]));

export const DIRECTIONS = [
  { value: "offer", label: "To Offer", short: "Offering",
    icon: Handshake, hint: "What you can give in a trade" },
  { value: "looking_for", label: "Looking For", short: "Looking for",
    icon: ArrowLeftRight, hint: "What you'd love to receive" },
];

export const DIR_MAP = Object.fromEntries(DIRECTIONS.map((d) => [d.value, d]));

export function CategoryChip({ value, className = "" }) {
  const c = CAT_MAP[value];
  if (!c) return null;
  const Icon = c.icon;
  return (
    <span
      className={`inline-flex items-center gap-1.5 text-xs font-medium px-2.5 py-1 rounded-full ${className}`}
      style={{ background: c.color, color: c.ink }}
      data-testid={`vendtrade-cat-chip-${value}`}
    >
      <Icon size={12} />
      {c.label}
    </span>
  );
}

export function DirectionPill({ value, className = "" }) {
  const d = DIR_MAP[value];
  if (!d) return null;
  const isOffer = value === "offer";
  return (
    <span
      className={`inline-flex items-center gap-1.5 text-[10px] uppercase tracking-widest px-2 py-0.5 rounded-full font-semibold ${className}`}
      style={{
        background: isOffer ? "rgba(111,125,85,0.14)" : "rgba(196,79,54,0.12)",
        color: isOffer ? "var(--moss)" : "var(--terracotta)",
      }}
      data-testid={`vendtrade-dir-pill-${value}`}
    >
      {d.short}
    </span>
  );
}
